<template>
    <DefaultLayout>
        <div v-if="showCreditCardForm">
            <CreditCardHeroBannerForm :monevo-logo="themeSetting('hero_form_monevo_logo')" />
        </div>
        <div v-else>
            <HeroBannerForm :monevo-logo="themeSetting('hero_form_monevo_logo')" />
        </div>

        <div v-if="showDynamicRatesTables">
            <DynamicRatesTable :app-url="url('/')" />
        </div>
        <div v-else>
            <LenderRatesTable :app-url="url('/')" />
        </div>

        <div v-if="showCreditCardForm">
            <CreditCardCtaForm />
        </div>
        <div v-else>
            <CtaForm />
        </div>
    </DefaultLayout>
</template>

<script>
import { useStore } from 'vuex'

export default {
    setup() {
        const store = useStore()

        return {
            store,
        }
    },
    data() {
        return {
            is_dynamic_rate_table: this.themeSetting('is_dynamic_rate_table'),
        }
    },
    computed: {
        showDynamicRatesTables() {
            return this.is_dynamic_rate_table === '1'
        },
        showCreditCardForm() {
            return window.CAMPAIGN_TYPE === 'Credit Card'
        },
    },
    provide() {
        return {
            isDynamicRatesTables: this.showDynamicRatesTables,
        }
    },
}
</script>
